import { Box, Container } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import styled from 'styled-components'

import PanelSubscriptions from '../components/profile/subscriptions/PanelSubscriptions'
import SubscriptionPromoHeader from '../components/subscriptions/SubscriptionPromoHeader'
import SubscriptionPromoMessage from '../components/subscriptions/SubscriptionPromoMessage'
import { useSubscriptionDetails } from '../hooks/subscriptions'
import { loadLocationStart } from '../redux/modules/location'
import { homeRoute } from '../routes/routes'

export const PageUnlimitedDelivery = () => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const { subscriptionDetails } = useSubscriptionDetails()
  const location = useSelector(state => state?.location?.location)
  const subscriptionFee = useSelector(state => state?.location?.location?.subscriptionFee)
  const locationId = useSelector(state => state?.user?.currentUser?.deliveryLocationId)
  const [didSubscribe, setDidSubscribe] = useState(false)

  // Consts
  const hasHadPrevSub = !isEmpty(subscriptionDetails?.status)
  const bodyText = `Get free delivery on all orders when you subscribe for $${subscriptionFee}/month.`
  const bodyTextAlt = hasHadPrevSub
    ? 'Cancel any time.'
    : 'Enjoy your first month free! Cancel any time.'

  // Effects
  useEffect(() => {
    locationId && dispatch(loadLocationStart(locationId))
  }, [dispatch, locationId])

  return (
    <Component disableGutters maxWidth={false} muiTheme={theme}>
      <Box margin="auto" maxWidth="520px" paddingY={4} position="relative" zIndex="1">
        <PanelSubscriptions
          component={Container}
          header={
            <>
              <SubscriptionPromoHeader />
              <BackgroundIllustration />
            </>
          }
          location={location}
          message={
            <SubscriptionPromoMessage
              bodyText={bodyText}
              bodyTextAlt={bodyTextAlt}
              subscriptionFee={subscriptionFee}
            />
          }
          onSubscribeSuccess={() => setDidSubscribe(true)}
        />
      </Box>
      {(subscriptionDetails?.enabled || didSubscribe) && <Redirect to={homeRoute.path} />}
    </Component>
  )
}

const BackgroundIllustration = () => (
  <Box alignItems="center" display="flex" justifyContent="center" marginTop="-120px" paddingY={4}>
    <img
      alt=""
      src="https://images.foodsby.com/conweb/unlimited_delivery_promo_5242020.svg"
      width="400px"
    />
  </Box>
)

const Component = styled(Container)`
  min-height: calc(100vh - 217px);
`

export default PageUnlimitedDelivery
